import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'big-ui-card',
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
    public readonly hasLink = input.required<boolean>();
    public readonly isComplex = input<boolean>(false);

    public readonly customClass = input<string>('bg-white dark:bg-primary');
}
